import { Box, Skeleton, Stack } from '@mui/material';

const TabsSkeleton = ({ count = 4, width }) => {
  return (
    <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0' }}>
      <Stack direction='row' spacing={2} sx={{ px: 1, py: 1.5 }}>
        {Array.from({ length: count }).map((_, idx) => (
          <Skeleton
            key={idx}
            variant='rectangular'
            height={20}
            width={width ? width : 140}
            sx={{ borderRadius: '4px' }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default TabsSkeleton;
